import * as actionTypes from '../actionTypes';

const state = {
  account: '',
  userPlan: '',
  userRoles: [],
  userExpirationDate: null,
  userActiveDate: null,
  startupCodeMaximumCount: null,
  participantsMaximumCount: null,
  expirationDateReminder: null,
  isAnnual: false,
};

function accountFeatureReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.GET_PROFILE_FULFILLED: {
      const actionData = action.data.data;
      let actionDataState = state;

      if (actionData) {
        actionDataState = {
          account: actionData.account ?? '',
          userPlan: actionData.versionName ?? '',
          userRoles: actionData.roles ?? [],
          userExpirationDate: actionData.endTime ?? null,
          userActiveDate: actionData.startTime ?? null,
          startupCodeMaximumCount: actionData.maxStartupCode ?? null,
          participantsMaximumCount: actionData.maxUser ?? null,
          expirationDateReminder: actionData.days ?? null,
          isAnnual: actionData.isAnnaul ?? false,
        };
      }

      return {
        ...globalState,
        ...actionDataState,
      };
    }
    default:
      return globalState;
  }
}

export { accountFeatureReducer as default };
